export const CHUNK_SIZE = 250;

/**
 * Splits payloads into chunks of maximum size CHUNK_SIZE
 * Supports three different input formats:
 * 1. Simple array of IDs (used in deleteCropZonesInBulk)
 * 2. Object or array of objects with cropZoneIds (legacy format)
 * 3. Object or array of objects with cropZones (V2 format)
 *
 * @param {Array|Object} input - Array of IDs, single object or array of objects
 * @returns {Array} Array of payloads split into chunks
 */
function splitCropZones(input) {
  // If not an array, convert to array with a single item
  const payloads = Array.isArray(input) ? input : [input];

  if (payloads.length === 0) {
    return [];
  }

  const result = [];

  // Case 1: Simple array of IDs (for delete)
  if (typeof payloads[0] !== 'object') {
    for (let i = 0; i < payloads.length; i += CHUNK_SIZE) {
      result.push(payloads.slice(i, i + CHUNK_SIZE));
    }
    return result;
  }

  // Case 2 and 3: Objects with cropZoneIds or cropZones
  payloads.forEach(payload => {
    // Case 2: Objects with cropZoneIds (legacy format)
    if (payload?.cropZoneIds && Array.isArray(payload.cropZoneIds)) {
      if (payload.cropZoneIds.length <= CHUNK_SIZE) {
        result.push(payload);
        return;
      }

      for (let i = 0; i < payload.cropZoneIds.length; i += CHUNK_SIZE) {
        result.push({
          ...payload,
          cropZoneIds: payload.cropZoneIds.slice(i, i + CHUNK_SIZE)
        });
      }
      return;
    }

    // Case 3: Objects with cropZones (V2 format)
    if (payload?.cropZones && Array.isArray(payload.cropZones)) {
      if (payload.cropZones.length <= CHUNK_SIZE) {
        result.push(payload);
        return;
      }

      for (let i = 0; i < payload.cropZones.length; i += CHUNK_SIZE) {
        result.push({
          ...payload,
          cropZones: payload.cropZones.slice(i, i + CHUNK_SIZE)
        });
      }
      return;
    }

    // Default case: add the payload as is
    result.push(payload);
  });

  return result;
}

export default splitCropZones;
